import styled from 'styled-components';

import Button from '@components/Button';
import { Row, SimpleButton } from '@components/formStyles';

export const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 40px 40px 16px 40px;
  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 3px 0 2px 0;
  }
`;
export const ContainerRoomDetail = styled.div`
  height: auto;

  position: relative;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 3px 0 2px 0;
  }
`;

export const Wrapper = styled.div`
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 54px 26px 16px 26px;
  margin-top: 3px;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px 0 2px 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    border: none;
    padding: 15px 16px;
  }
`;

export const StyledRow = styled(Row)`
  min-width: 95px;
  margin-top: 20px;
  text-align: center;
  justify-content: center;
`;

export const CardContainer = styled.div``;

export const TabWrapper = styled.div<{ direction: string }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 77px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.lightsSilver};
  overflow-y: auto;
  position: sticky;
  top: ${({ direction }) => (direction === 'down' ? '49px' : '147px')};
  transition: all 0.19s;

  background-color: ${({ theme }) => theme.palette.white};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    top: 185px;
  }
`;

export const RoomWrapper = styled.div`
  &:after {
    content: '';
    display: table;
    clear: both;
  }
`;

export const RoomColumn = styled.div`
  float: left;
  width: 384px;

  margin-bottom: 24px;
  margin-right: 24px;
  &:nth-child(3n) {
    margin-right: 0;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-right: 0;
    margin-bottom: 12px;
  }
`;

export const Title = styled.h3`
  font-size: 24px;
  color: ${({ theme }) => theme.palette.grey1100};
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 24px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    line-height: 24px;
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  margin-bottom: 24px;
  gap: 24px;
  .date-input-component {
    width: 186px !important;

    border-radius: 8px;
  }
  .select-guest-component {
    width: 384px !important;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    .date-input-component {
      width: 100% !important;
      margin-right: 0;
      margin-bottom: 12px;
    }
    .select-guest-component {
      width: 10px !important;
    }
  }
`;

export const GuestComponent = styled.div`
  margin: 0 0;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 12px 0;
  }
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const SearchbarButton = styled(Button)`
  width: 384px;
  height: 56px !important;
  margin-top: 21px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 12px;
    width: 100%;
  }
`;

export const SelectedVariationsWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  padding: 12px 16px;
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
`;

export const DynamicRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RoomText = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 20px;
  font-weight: 700;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const Line = styled.div`
  width: 1px;
  height: 56px;
  background-color: ${({ theme }) => theme.palette.grey300};
  margin: 0 24px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    height: 1px;
    margin: 12px 0;
  }
`;

export const RoomTitle = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 16px;
  font-weight: 600;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 8px;
  }
`;

export const RoomDescription = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.grey800};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 4px;
  }
`;

export const DeleteButton = styled(SimpleButton)`
  position: absolute;
  right: 16px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    top: 12px;
  }
`;

export const RoomType = styled(RoomDescription)`
  border-left: 1px solid ${({ theme }) => theme.palette.grey300};
  padding-left: 12px;
  margin-left: 12px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    border-left: 0;
    margin-left: 0;
    padding-left: 0;
  }
`;

export const RoomImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  margin-right: 16px;
  object-fit: cover;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;
